module.exports = __webpack_public_path__ + "img/crossmark.8fbf55ab.svg";